export enum OsType {
  MAC = 0,
  WINDOWS = 1,
  UNKNOWN = 3
}

export const useOs = (): OsType => {
  const platform = window.navigator.platform;
  const macosPlatforms = ['mac', 'macintosh', 'macintel', 'macppc', 'mac68k'];
  const windowsPlatforms = ['win32', 'win64', 'windows', 'wince'];

  if (macosPlatforms.indexOf(platform.toLowerCase()) !== -1) return OsType.MAC;
  else if (windowsPlatforms.indexOf(platform.toLowerCase()) !== -1)
    return OsType.WINDOWS;

  return OsType.UNKNOWN;
};
